export enum PurchaseOrderStatus {
  DRAFT = 'DRAFT',
  READY = 'READY',
  REQUESTING = 'REQUESTING',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  FULFILLED = 'FULFILLED'
}
